import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const GlobalStyle = css`
  @import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css');
  @import url('https://fonts.googleapis.com/css2?family=Reddit+Sans:wght@700;800&display=swap');

  body {
    background-color: #161616;
    color: #ffffff;
    font-family: 'Pretendard', sans-serif;
    margin: 0;
    padding: 0;
    overflow-x: hidden;
  }
  
  * {
    box-sizing: border-box;
  }
`;

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  position: relative;
`;

export const BackgroundEffect = styled.img`
  position: absolute;
  top: -80px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 2584px;
  height: auto;
  z-index: -1;
  opacity: 0.6;
  pointer-events: none;
`;

export const HeaderContainer = styled.header`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 60px;
  background-color: #000000;
  padding: 0 40px;
  box-sizing: border-box;
`;

export const LogoFrame = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 4px;
`;

export const LogoIcon = styled.img`
  width: 40px;
  height: 40px;
`;

export const HeaderTitle = styled.h1`
  font-family: 'Reddit Sans', sans-serif;
  font-weight: 700;
  font-size: 28px;
  margin: 0;
  color: #ffffff;
  line-height: 1.3;
`;

export const MainContent = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1000px;
  padding: 0 20px;
  gap: 20px;
`;

export const MainTitle = styled.h2`
  font-family: 'Reddit Sans', sans-serif;
  font-weight: 700;
  font-size: 40px;
  color: #ffffff;
  margin: 0;
  line-height: 1.3;
  text-align: center;
  align-self: center;
`;

export const FormContainer = styled.div`
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 20px;
  padding: 60px;
  display: flex;
  flex-direction: column;
  gap: 60px;
  width: 100%;
`;

export const StepHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const StepInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StepTag = styled.div`
  background-color: rgba(0, 137, 207, 0.2);
  border-radius: 8px;
  width: 100px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StepTagText = styled.span`
  font-family: 'Reddit Sans', sans-serif;
  font-weight: 700;
  font-size: 24px;
  color: #0089CF;
`;

export const StepTitle = styled.h3`
  font-family: 'Reddit Sans', sans-serif;
  font-weight: 700;
  font-size: 32px;
  color: #0089CF;
  margin: 0;
  margin-left: 8px;
`;

export const ProcessBar = styled.img`
  height: 48px;
  width: auto;
`;

export const Footer = styled.footer`
  margin-top: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
  height: 140px;
  justify-content: center;
  margin-top: 100px;
  background-color: #000000;
`;

export const FooterLogo = styled.img`
  width: 220px;
  height: 40px;
`;

export const Copyright = styled.span`
  font-family: 'Pretendard', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
`;
